export const DEFAULT_PLAN_ID = 'free';
